import * as moment from 'moment';
import { Moment } from 'moment';
import ProjectChildComment from 'src/entities/ProjectChildComment';

export default class ProjectComment {
  id?: number;
  body: string;
  authorId?: number;
  authorName?: string;
  projectId: number;
  createdAt?: Moment;
  childComments: Array<ProjectChildComment>;

  constructor(entity: ProjectComment) {
    this.id = entity.id || undefined;
    this.body = entity.body;
    this.authorId = entity.authorId || undefined;
    this.authorName = entity.authorName || undefined;
    this.projectId = entity.projectId;
    this.createdAt = moment(entity.createdAt) || undefined;
    this.childComments = entity.childComments ?
      entity.childComments.map(childComment => new ProjectChildComment(childComment)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/entities/ProjectComment.tsx